export const SeatConfig = {
    cinemove: {
        id: "cinemove",
        models: [
            {
                name: "black",
                gltf: "assets/models/Seat_CineMove001/black/Seat_CineMove001.gltf"
            },
            {
                name: "red",
                gltf: "assets/models/Seat_CineMove001/red/Seat_CineMove001.gltf"
            }
        ],
        // a model containing a human sitting in the seat (used for sight-lines)
        occupant: "assets/models/Humans/HumanCineHomeDeluxe001.gltf",
        // the distance between two rows (= seatDepth + legRoom)
        rowDepth: 100,
        // the height of a row
        rowHeight: 40,
        // the distance between the anchor point and the backside of the chair, to allow for distance between the back wall
        recline: 30,
        // the physical dimensions of the chair in cm [w, h, d], WITHOUT 1 armrest
        size: [ 58, 108.5, 76 ],
        // the width of one armrest (to fill out a row)
        armrestWidth: 10.2,
        url: "https://www.cinedream.be/artikelgroep/cine-move"
    },
    roma: {
        id: "roma",
        models: [
            {
                name: "black",
                gltf: "assets/models/Seat_RomaElite001/Seat_Roma001.gltf"
            }
        ],
        occupant: "assets/models/Humans/HumanSelena001.gltf",
        rowDepth: 199,
        rowHeight: 20,
        recline: 40,
        size: [ 77, 112, 99 ],
        // the width of one armrest (to fill out a row)
        armrestWidth: 15,
        url: "https://www.cinedream.be/artikelgroep/roma-elite-cinedream-edition"
    },
    cinehomedeluxe: {
        id: "cinehomedeluxe",
        models: [
            {
                name: "red",
                gltf: "assets/models/Seat_CineHomeDeluxe/Seat_CineHomeDeluxe_001.gltf"
            }
        ],
        occupant: "assets/models/Humans/HumanCineHomeDeluxe001.gltf",
        // the distance between two rows (= seatDepth + legRoom)
        rowDepth: 100,
        // the height of a row
        rowHeight: 40,
        // the distance between the anchor point and the backside of the chair, to allow for distance between the back wall
        recline: 30,
        // the physical dimensions of the chair in cm [w, h, d], WITHOUT 1 armrest
        size: [ 58, 108.5, 76 ],
        // the width of one armrest (to fill out a row)
        armrestWidth: 10.2,
        url: "https://www.cinedream.be/artikelgroep/cine-home-deluxe"
    },
    selena: {
        id: "selena",
        models: [
            {
                name: "black",
                gltf: "assets/models/Seat_Selena/Seat_Selena_001.gltf"
            }
        ],
        occupant: "assets/models/Humans/HumanSelena001.gltf",
        rowDepth: 199,
        rowHeight: 40,
        recline: 20,
        size: [ 77, 112, 99 ],
        // the width of one armrest (to fill out a row)
        armrestWidth: 15,
        url: "https://www.cinedream.be/artikelgroep/selena"
    },
    odeon: {
        id: "odeon",
        models: [
            {
                name: "grey",
                gltf: "assets/models/Seat_OdeonSubstance/Odeon_Substance001.gltf"
            },
            {
                name: "black",
                gltf: "assets/models/Seat_OdeonSubstance_black/Odeon_Substance001.gltf"
            },
            {
                name: "blue",
                gltf: "assets/models/Seat_OdeonSubstance_blue/Odeon_Substance001.gltf"
            },
            {
                name: "bordeaux",
                gltf: "assets/models/Seat_OdeonSubstance_bordeaux/Odeon_Substance001.gltf"
            },
        ],
        occupant: "assets/models/Humans/HumanOdeon001.gltf",
        rowDepth: 199,
        rowHeight: 40,
        recline: 20,
        size: [ 78, 110, 107 ],
        // the width of one armrest (to fill out a row)
        armrestWidth: 22,
        url: "https://www.cinedream.be/artikelgroep/odeon"
    }
};
